import React from "react";
import PropTypes from "prop-types";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

const EDITABLE_BASE_NAMES = new Set(["Not Started", "Re-assign Task", "Archive", "Un-Archive", "Teams Chat", "In Progress"]);

const SystemActionRow = ({ field, index, onHide, onOpen }) => {
  const editable = EDITABLE_BASE_NAMES.has(field?.Name);
  const hideDisabled = field?.AutomaticTriggers !== "";

  return (
    <div className="individual-workflow" id={`workflowstatusBase_${index}`}>
      <div className="individual-workflow-status">
        <span className="status-index">{index + 1}</span>
        <div className="field-container-base-status pl-2">
          {field?.Name}
          <OverlayTrigger
            placement="top"
            delay={{ show: 150, hide: 150 }}
            overlay={
              <Tooltip id="button-tooltip">
                { field.AutomaticTriggers !== ""
                    ? "This System Task Action is set to be automatically triggered and can’t be hidden."
                    : "Click to Hide"
                }
              </Tooltip>
            }
          >
            <Button
              className={`btn-icon1 hide-eye-icon ${hideDisabled ? "hide-eye-icon-disabled" : ""}`}
              onClick={() => {
                if (!hideDisabled) onHide(field.Id, field?.IsHidden);
              }}
              type="button"
            />
          </OverlayTrigger>
        </div>

        { editable
          ? <Button className="btn-icon1 open-modal" onClick={() => onOpen(field)} type="button" />
          : <OverlayTrigger
              placement="top"
              delay={{ show: 150, hide: 150 }}
              overlay={<Tooltip id="button-tooltip">TRIYO created this System Task Action. You can’t edit its name and properties.</Tooltip>}
            >
              <Button className="btn-icon1 lock-closed-icon" type="button" />
            </OverlayTrigger>
        }
      </div>
    </div>
  );
};

SystemActionRow.propTypes = {
  field: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onHide: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
};

export default SystemActionRow;
